<template>
    <v-card class="default_card large" elevation="0">
        <v-row class="d-flex justify-center">
            <v-col cols="2"> </v-col>
            <v-col cols="4" class="px-1 py-3">
                <oss-accounting-period-selector
                    v-model="accountingPeriod"
                    :global="false"
                    :company-id="companyId"
                    hide-details
                    density="compact"
                />
            </v-col>
            <v-col cols="4" class="px-1 py-3">
                <oss-text-field
                    v-model="accountingPeriod.amountSubsciption"
                    density="compact"
                    hide-details
                    label="Montant du forfait"
                />
            </v-col>
            <v-col cols="2" class="d-flex justify-end align-center px-3">
                <v-btn rounded @click="update()" size="small"> Valider </v-btn>
            </v-col>
            <v-col cols="12" v-if="accountingPeriod.amountSubsciption">
                <DoughnutChart
                    :data="dataset"
                    :options="chartOptions"
                    :height="$vuetify.display.mobile ? 200 : 350"
                />
            </v-col>
            <v-col cols="12" v-else class="d-flex justify-center pa-8 subtitle-1">
                Entrez un montant pour le forfait
            </v-col>
        </v-row>
    </v-card>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import ossAccountingPeriodSelector from "../ossComponents/ossAccountingPeriodSelector.vue";

import { Doughnut as DoughnutChart } from "vue-chartjs";

import BONI_MALI_COMPANY from "../../graphql/boniMali/BoniMaliCompany.gql";
import UPDATE_AMOUNT_SUBSCRIPTION from "../../graphql/boniMali/UpdateSubscriptionAmount.gql";
import { Prop, Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        ossAccountingPeriodSelector,
        DoughnutChart,
    },
})
export class BoniMali extends Vue {
    @Prop({ default: "" }) companyId: string;

    loading = false;

    accountingPeriod = {
        id: "",
        start: "",
        end: "",
        amountSubsciption: 0,
    };

    get sum() {
        return this.boniMalies
            .map((x) => x.user.hourlyCost * (x.duration / 60))
            .reduce((a, b) => a + b, 0);
    }

    get subscriptionPrice() {
        return 2000;
    }

    get dataset() {
        const used = this.sum;
        const subscription = +this.accountingPeriod.amountSubsciption;
        const rest = subscription - used;
        let subscriptionData = [];
        let backgroundColors = [];
        let labels = [];

        if (rest >= 0) {
            subscriptionData = [used, rest];
            backgroundColors = ["#1ABC9C", "#EAEAEA"];
            labels = ["Montant utilisé: " + used, "Marge (Boni): " + rest];
        } else {
            subscriptionData = [-rest, subscription];
            backgroundColors = ["#F44336", "#EAEAEA"];
            labels = ["Parte (Mali): " + -rest, "Montant du forfait: " + subscription];
        }

        debugger;
        return {
            labels: labels,
            datasets: [
                {
                    backgroundColor: backgroundColors,
                    borderColor: ["#FFF"],
                    label: "Forfait",
                    data: subscriptionData,
                },
            ],
        };
    }

    get chartOptions() {
        return {
            plugins: { legend: { display: true, position: "right" } },
            maintainAspectRatio: false,
        };
    }

    skip = false;

    @Apollo({
        query: BONI_MALI_COMPANY,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriod.id,
            };
        },
        skip() {
            return !(this.accountingPeriod && this.accountingPeriod.id);
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                if (data && data.manualUserActivities && data.manualUserActivities.length) {
                    this.boniMalies = data.manualUserActivities;
                    this.loading = false;
                }
            }
        },
    })
    boniMalies = [];

    async update() {
        await this.$apollo.mutate({
            mutation: UPDATE_AMOUNT_SUBSCRIPTION,
            variables: {
                id: this.accountingPeriod.id,
                amount: Math.round(this.accountingPeriod.amountSubsciption),
            },
        });
    }
}

export default toNative(BoniMali);
</script>

<style></style>
